import { H5, Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { Link } from "react-router-dom";
import { UserInformationNameProp } from "../../../../Type/DashboardType";

export const UserInformationName = ({ image, title, spanText }: UserInformationNameProp) => {
  return (
    <td>
      <div className="d-flex align-items-center">
        <Image src={dynamicImage(`dashboard/user/${image}`)} alt="" />
        <div className="flex-grow-1 ms-2">
          <Link to={`${process.env.PUBLIC_URL}/ecommerce/product-list`}>
            <H5>{title}</H5>
            <span>{spanText}</span>
          </Link>
        </div>
      </div>
    </td>
  );
};
